import axios from 'axios';
import { DIAGNOCAT_URL } from '../assets/conf/api-endpoints';

const instance = axios.create({
    baseURL: DIAGNOCAT_URL,
});

export default instance;
